// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file integrations/v1/order.proto (package integrations.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Environment } from "../../common/v1/environment_pb";
import { file_common_v1_environment } from "../../common/v1/environment_pb";
import type { Gateway } from "../../common/v1/gateway_pb";
import { file_common_v1_gateway } from "../../common/v1/gateway_pb";
import type { Address, BillingAddress } from "../../common/v1/address_pb";
import { file_common_v1_address } from "../../common/v1/address_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file integrations/v1/order.proto.
 */
export const file_integrations_v1_order: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_environment, file_common_v1_gateway, file_common_v1_address, file_google_protobuf_timestamp]);

/**
 * @generated from message integrations.v1.Order
 */
export type Order = Message<"integrations.v1.Order"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: integrations.v1.OrderStatus status = 2;
   */
  status: OrderStatus;

  /**
   * @generated from field: common.v1.Environment environment = 3;
   */
  environment: Environment;

  /**
   * @generated from field: repeated integrations.v1.OrderItem items = 4;
   */
  items: OrderItem[];

  /**
   * @generated from field: repeated string available_countries = 5;
   */
  availableCountries: string[];

  /**
   * @generated from field: optional common.v1.BillingAddress billing_address = 6;
   */
  billingAddress?: BillingAddress;

  /**
   * @generated from field: optional common.v1.Address shipping_address = 7;
   */
  shippingAddress?: Address;

  /**
   * @generated from field: optional integrations.v1.OrderDetails details = 8;
   */
  details?: OrderDetails;

  /**
   * @generated from field: optional integrations.v1.Customer customer = 9;
   */
  customer?: Customer;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message integrations.v1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema: GenMessage<Order> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 0);

/**
 * @generated from message integrations.v1.OrderDetails
 */
export type OrderDetails = Message<"integrations.v1.OrderDetails"> & {
  /**
   * @generated from field: common.v1.Gateway gateway = 1;
   */
  gateway: Gateway;

  /**
   * @generated from field: repeated integrations.v1.DeliveryMethod delivery_methods = 2;
   */
  deliveryMethods: DeliveryMethod[];

  /**
   * @generated from field: optional int64 delivery_method_price = 3;
   */
  deliveryMethodPrice?: bigint;

  /**
   * @generated from field: optional string delivery_method = 4;
   */
  deliveryMethod?: string;

  /**
   * @generated from field: bool ask_for_phone = 6;
   */
  askForPhone: boolean;

  /**
   * @generated from field: bool ask_for_note = 7;
   */
  askForNote: boolean;

  /**
   * @generated from field: bool ask_for_nip = 8;
   */
  askForNip: boolean;

  /**
   * @generated from field: optional string coupon_code = 9;
   */
  couponCode?: string;

  /**
   * @generated from field: optional int64 coupon_discount_amount = 10;
   */
  couponDiscountAmount?: bigint;

  /**
   * @generated from field: optional string coupon_discount_currency = 11;
   */
  couponDiscountCurrency?: string;

  /**
   * @generated from field: optional string coupon_discount_type = 12;
   */
  couponDiscountType?: string;

  /**
   * @generated from field: optional bool coupon_includes_delivery = 13;
   */
  couponIncludesDelivery?: boolean;

  /**
   * @generated from field: optional string success_url = 14;
   */
  successUrl?: string;

  /**
   * @generated from field: optional string cancel_url = 15;
   */
  cancelUrl?: string;

  /**
   * @generated from field: optional string payment_gateway_id = 16;
   */
  paymentGatewayId?: string;

  /**
   * @generated from field: map<string, string> metadata = 17;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: repeated integrations.v1.CheckoutAgreement additional_agreements = 18;
   */
  additionalAgreements: CheckoutAgreement[];
};

/**
 * Describes the message integrations.v1.OrderDetails.
 * Use `create(OrderDetailsSchema)` to create a new message.
 */
export const OrderDetailsSchema: GenMessage<OrderDetails> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 1);

/**
 * @generated from message integrations.v1.CheckoutAgreement
 */
export type CheckoutAgreement = Message<"integrations.v1.CheckoutAgreement"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: bool required = 4;
   */
  required: boolean;

  /**
   * @generated from field: optional bool answer = 5;
   */
  answer?: boolean;
};

/**
 * Describes the message integrations.v1.CheckoutAgreement.
 * Use `create(CheckoutAgreementSchema)` to create a new message.
 */
export const CheckoutAgreementSchema: GenMessage<CheckoutAgreement> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 2);

/**
 * @generated from message integrations.v1.Metadata
 */
export type Metadata = Message<"integrations.v1.Metadata"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from oneof integrations.v1.Metadata.value
   */
  value: {
    /**
     * @generated from field: string string_value = 2;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: bool boolean_value = 3;
     */
    value: boolean;
    case: "booleanValue";
  } | {
    /**
     * @generated from field: int64 number_value = 4;
     */
    value: bigint;
    case: "numberValue";
  } | {
    /**
     * @generated from field: string select_value = 5;
     */
    value: string;
    case: "selectValue";
  } | {
    /**
     * @generated from field: integrations.v1.Metadata.ArrayValue array_value = 6;
     */
    value: Metadata_ArrayValue;
    case: "arrayValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message integrations.v1.Metadata.
 * Use `create(MetadataSchema)` to create a new message.
 */
export const MetadataSchema: GenMessage<Metadata> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 3);

/**
 * @generated from message integrations.v1.Metadata.ArrayValue
 */
export type Metadata_ArrayValue = Message<"integrations.v1.Metadata.ArrayValue"> & {
  /**
   * @generated from field: repeated integrations.v1.Metadata.ArrayValue.Element elements = 1;
   */
  elements: Metadata_ArrayValue_Element[];
};

/**
 * Describes the message integrations.v1.Metadata.ArrayValue.
 * Use `create(Metadata_ArrayValueSchema)` to create a new message.
 */
export const Metadata_ArrayValueSchema: GenMessage<Metadata_ArrayValue> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 3, 0);

/**
 * @generated from message integrations.v1.Metadata.ArrayValue.Element
 */
export type Metadata_ArrayValue_Element = Message<"integrations.v1.Metadata.ArrayValue.Element"> & {
  /**
   * @generated from oneof integrations.v1.Metadata.ArrayValue.Element.value
   */
  value: {
    /**
     * @generated from field: string string_value = 1;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: bool boolean_value = 2;
     */
    value: boolean;
    case: "booleanValue";
  } | {
    /**
     * @generated from field: float float_value = 3;
     */
    value: number;
    case: "floatValue";
  } | {
    /**
     * @generated from field: int64 number_value = 4;
     */
    value: bigint;
    case: "numberValue";
  } | {
    /**
     * json
     *
     * @generated from field: bytes object_value = 5;
     */
    value: Uint8Array;
    case: "objectValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message integrations.v1.Metadata.ArrayValue.Element.
 * Use `create(Metadata_ArrayValue_ElementSchema)` to create a new message.
 */
export const Metadata_ArrayValue_ElementSchema: GenMessage<Metadata_ArrayValue_Element> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 3, 0, 0);

/**
 * @generated from message integrations.v1.OrderItem
 */
export type OrderItem = Message<"integrations.v1.OrderItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;

  /**
   * @generated from field: int64 price = 3;
   */
  price: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * @generated from field: optional int32 tax = 5;
   */
  tax?: number;

  /**
   * @generated from field: optional string name = 6;
   */
  name?: string;

  /**
   * @generated from field: optional integrations.v1.Recurring recurring = 7;
   */
  recurring?: Recurring;
};

/**
 * Describes the message integrations.v1.OrderItem.
 * Use `create(OrderItemSchema)` to create a new message.
 */
export const OrderItemSchema: GenMessage<OrderItem> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 4);

/**
 * @generated from message integrations.v1.Customer
 */
export type Customer = Message<"integrations.v1.Customer"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: optional string phone = 2;
   */
  phone?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;
};

/**
 * Describes the message integrations.v1.Customer.
 * Use `create(CustomerSchema)` to create a new message.
 */
export const CustomerSchema: GenMessage<Customer> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 5);

/**
 * @generated from message integrations.v1.DeliveryMethod
 */
export type DeliveryMethod = Message<"integrations.v1.DeliveryMethod"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 min = 2;
   */
  min: number;

  /**
   * @generated from field: int32 max = 3;
   */
  max: number;

  /**
   * @generated from field: int64 price = 4;
   */
  price: bigint;
};

/**
 * Describes the message integrations.v1.DeliveryMethod.
 * Use `create(DeliveryMethodSchema)` to create a new message.
 */
export const DeliveryMethodSchema: GenMessage<DeliveryMethod> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 6);

/**
 * @generated from message integrations.v1.Recurring
 */
export type Recurring = Message<"integrations.v1.Recurring"> & {
  /**
   * @generated from field: integrations.v1.BillingPeriod billing_period = 1;
   */
  billingPeriod: BillingPeriod;

  /**
   * @generated from field: optional int32 trial_days = 2;
   */
  trialDays?: number;

  /**
   * @generated from field: optional int32 number_of_payments = 3;
   */
  numberOfPayments?: number;
};

/**
 * Describes the message integrations.v1.Recurring.
 * Use `create(RecurringSchema)` to create a new message.
 */
export const RecurringSchema: GenMessage<Recurring> = /*@__PURE__*/
  messageDesc(file_integrations_v1_order, 7);

/**
 * @generated from enum integrations.v1.OrderStatus
 */
export enum OrderStatus {
  /**
   * @generated from enum value: CREATED = 0;
   */
  CREATED = 0,

  /**
   * @generated from enum value: PAID = 1;
   */
  PAID = 1,

  /**
   * @generated from enum value: UNPAID = 2;
   */
  UNPAID = 2,

  /**
   * @generated from enum value: CANCELED = 3;
   */
  CANCELED = 3,
}

/**
 * Describes the enum integrations.v1.OrderStatus.
 */
export const OrderStatusSchema: GenEnum<OrderStatus> = /*@__PURE__*/
  enumDesc(file_integrations_v1_order, 0);

/**
 * @generated from enum integrations.v1.BillingPeriod
 */
export enum BillingPeriod {
  /**
   * @generated from enum value: DAILY = 0;
   */
  DAILY = 0,

  /**
   * @generated from enum value: WEEKLY = 1;
   */
  WEEKLY = 1,

  /**
   * @generated from enum value: MONTHLY = 2;
   */
  MONTHLY = 2,

  /**
   * @generated from enum value: QUARTERLY = 3;
   */
  QUARTERLY = 3,

  /**
   * @generated from enum value: SEMI_ANNUALLY = 4;
   */
  SEMI_ANNUALLY = 4,

  /**
   * @generated from enum value: ANNUALLY = 5;
   */
  ANNUALLY = 5,
}

/**
 * Describes the enum integrations.v1.BillingPeriod.
 */
export const BillingPeriodSchema: GenEnum<BillingPeriod> = /*@__PURE__*/
  enumDesc(file_integrations_v1_order, 1);

